// extracted by mini-css-extract-plugin
export default {"background_wrapper":"BackgroundShortz_background_wrapper__NRVQi","wrapper":"BackgroundShortz_wrapper__QljdH","paddingBottom":"BackgroundShortz_paddingBottom__phAsL"};